<template>
  <div class="vp-input-box items-center">
    <slot />
  </div>
</template>
